/* 
  官方包钱包充值界面单独逻辑，其他为商品购买界面 
  蓝湖路径：YWWL -> 产品文档2020 -> 运营 -> 3627官方包微信页面
  设计稿：YWWL -> 设计稿 -> 微信防下架支付 -> 官方包充值
*/
<template>
  <div :class="$style.wallet">
    <img :src="`${$cdnUrl}/wallet_banner.png`" alt="" :class="$style.banner">
    <div :class="$style.selectAccount">
      <div :class="$style.accountInput">
        <span>充值账号：</span>
        <input 
          placeholder="请输入您的充值账号" 
          :class="$style.input" 
          v-model="username"
          @blur="handleInputBlur"
        />
        <!-- 签到按钮 -->
        <!-- <img :src="signSrc" alt="" :class="$style.sign" @click="execSign" > -->
      </div>
      <div :class="$style.selectWrap">
        <span>选择游戏：</span>
        <div :class="$style.selectGroup">
          <div>
            <CSelect 
              placeholder="选择游戏"
              :options="gameList"
              :value="appkey"
              @change="selectGame"
              @click.native="handleSelectClick('appkey')"
              ref="appkey"
            ></CSelect>
            <div :class="$style.brief" @click="showBrief">
              <img :src="`${$cdnUrl}/wallet_about.png`" alt="">
              <span>了解余额如何使用</span>
            </div>
          </div>
          <div>
            <CSelect 
              style="margin-right:10px;" 
              placeholder="选择区服"
              hint="暂无区服"
              :options="serverList"
              :value="server"
              @change="selectServer"
              ref="server"
              @click.native="handleSelectClick('server')"
            ></CSelect>
            <CSelect
              placeholder="选择角色"
              hint="暂无角色"
              :options="roleList"
              :value="role"
              ref="role"
              @change="selectRole"
              @click.native="handleSelectClick('role')"
            ></CSelect>
          </div>
        </div>
      </div>
    </div>
    <div :class="$style.balance">
      <div>
        <span>代币余额（元）</span>
        <p>账号下所有游戏角色都可以使用余额哦~</p>
      </div>
      <div>
        <span>{{balance}}</span>
        <i :class="`iconfont yw-shuaxin1 ${refreshState && $style.refreshStateActive}`" @click="refreshAmount"></i>
      </div>
    </div>
    <p :class="$style.refreshHint">*若您出现充值未到账，请尝试点击金额右侧刷新按钮</p>
    <div :class="$style.money">
      <div>充值金额</div>
      <div>
        <span 
          v-for="(item, index) in amountList" 
          :key="index" 
          :class="`${$style.amountItem} ${selectAmount === index && $style.active}`"
          @click="selectAccount(index, item)"
        >{{item}}</span>
        <div :class="`${$style.otherAmount} ${selectAmount === 'other' && $style.active}`" @click="selectAccount('other')">
          <input placeholder="其他" v-model="otherAmount" /><span>元</span>
        </div>
      </div>
    </div>
    <div :class="$style.payType">
      <div>支付方式</div>
      <radio-group v-model="pay_type">
        <cell-group :border="false">
          <cell title="微信" clickable @click="pay_type = wxPayType" :border="false" :icon="wxUrl">
            <radio slot="right-icon" :name="wxPayType" checked-color="#FF9600"/>
          </cell>
          <cell title="支付宝" clickable @click="pay_type = aliPayType" :border="false" :icon="aliUrl">
            <radio slot="right-icon" :name="aliPayType" checked-color="#FF9600"/>
          </cell>
        </cell-group>
      </radio-group>
    </div>
    <Button 
      type="primary" 
      block 
      :class="$style.submit"  
      color="linear-gradient(to right, #FF9600, #FF8000)"
      @click="placeOrder"
    >确认支付</Button>
    <Popup v-model="briefVisible" :class="$style.popUp">
      <h3>如何使用余额？</h3>
      <p>在页面中充值后，在游戏中可选择您需要购买的礼包、道具，点击购买按钮，极速到账，安全无忧。</p>
      <p>若您没有收到货物，请检查是否钱包余额不够，或者是重新上线即可。若您还有其他问题，请<span @click="customer">联系客服</span>处理。</p>
    </Popup>
    <!-- 微信里alipay提示 -->
    <div :class="$style.hint" v-show="hintState" @click="hintState=false"></div>
    <!--  签到弹窗 -->
    <Popup v-model="signVisible" :class="$style.signPopUp">
      <p :class="$style.selectRole" v-if="!role">请填写游戏账号，区服信息！</p>
      <div :class="$style.signSuccess" v-else>
        <p :class="$style.title">签到成功</p>
        <p>您已成功签到{{signDays}}天！</p>
        <!-- <p>回到游戏即可领取签到奖励！</p> -->
      </div>
      <Button type="primary" block style="width:80%;margin:auto"  color="#FF9600" @click="signVisible=false">确定</Button>
    </Popup>
  </div>
</template>

<script>
import CSelect from '@/components/Select';
import { Radio, Cell, CellGroup, RadioGroup, Button, Popup } from 'vant';

import { userRole, roleBind, getRoleInfo } from "@/api/account";
import { signInInfo, signIn, tokenOrder, tokenOrderPay, TOKEN_PAY_URL } from "@/api/pay";
import { QI_DIAN_URL_QQ, GetAppKey } from "@/config";
import { sort_ASCII } from "@/libs/utils";
import { isWeiXin } from "@/libs/utils";
import GameList from "@/config/game"
// import wxSdkInit from "@/libs/wx.init.js";

const WX_PAY_TYPE = '26'
const ALI_PAY_TYPE = '10'

export default {
  name: '',
  data () {
    return {
      balance: 0,
      amountList: [12, 50, 100, 500, 1000, 1600, 2000],
      pay_type: isWeiXin() ? WX_PAY_TYPE : ALI_PAY_TYPE,
      wxUrl: `${this.$cdnUrl}/wxpay.png`,
      aliUrl: `${this.$cdnUrl}/alipay.png`,
      gameList: [],
      username: '',
      appkey: '',
      server_name: '',
      server: '',
      role: '',
      role_name: '',
      user_id: '',
      pf_id: '',
      selectAmount: '',
      otherAmount: '',
      briefVisible: false,
      signVisible: false,
      // signSrc: `${this.$cdnUrl}/wallet_sign.png`,
      hintState: false,
      serverList: [], // 服务器可选列表
      roleList: [], // 角色可选列表
      lastParams: {},
      signDays: '', // 签到天数
      canSign: true, // 是否能签到
      wxPayType: WX_PAY_TYPE,
      aliPayType: ALI_PAY_TYPE,
      refreshState: false
    };
  },
  mounted() {
    this.initGameConfig();
    const { user_name } = this.$route.query;
    
    // 如果url中存在填写过的相关信息，说明是在微信内点击支付宝支付方式重定向的链接提供给外部浏览器打开使用；否则走一遍获取用户信息历史相关逻辑
    user_name ? this.handleQuery() : this.getUserInfo();
  },
  computed: {
    signSrc() {
      return this.canSign ? `${this.$cdnUrl}/wallet_sign.png` : `${this.$cdnUrl}/wallet_sign_1.png`
    }
  },
  components: {
    CSelect,
    Radio,
    RadioGroup,
    CellGroup,
    Cell,
    Button,
    Popup
  },
  methods: {
    handleInputBlur() {
      if (this.username !== this.lastParams.user_name && this.appkey) {
        this.getServerList()
        this.server = ''
        this.role = ''
      }
    },
    // 选择游戏
    selectGame({ text, value }) {
      this.appkey = value;
      if (value !== this.lastParams.appkey) {
        this.getServerList()
        this.server = ''
        this.role = ''
      }
    },
    // 选择服务器
    selectServer({ text, value, children }) {
      if (value !== this.server) {
        this.server = value;
        this.server_name = text;
        this.roleList = children;
        this.role = ''
      }
    },
    selectRole({ text, value, user_id, pf_id }) {
      this.role = value
      this.role_name = text;
      this.user_id = user_id;
      this.pf_id = pf_id;
      this.getSignInfo();
    },
    handleSelectClick(instance) {
      let instanceList = ['appkey', 'role', 'server'];
      instanceList = instanceList.filter(item => item !== instance);
      instanceList.map(item => {
        this.$refs[item].reset();
      })
    },
    selectAccount(i, amount) {
      this.selectAmount = i;
      if (i !== 'other') this.otherAmount = ''
    },
    showBrief() {
      this.briefVisible = true;
    },
    customer() {
      window.open(QI_DIAN_URL_QQ, "_blank");
    },
    // 让大哥在外面去花zfb里的钱充
    handleQuery() { 
      const { user_id, user_name, role_id, appkey, role_name, s_a, o_a, server_num, pay_type } = this.$route.query;
      this.username = user_name;
      this.appkey = appkey;
      if (server_num) {
        this.getServerList((serverList) => {
          this.roleList = serverList.find(item => item.value === server_num).children;
        });
      }
      this.server = server_num || this.server;
      this.role = role_id || this.role;
      this.role_name = role_name || this.role_name;
      this.user_id = user_id || this.user_id;
      if(s_a) this.selectAmount = s_a == 'other' ? 'other' : Number(s_a);
      this.otherAmount = o_a || this.otherAmount;
      this.pay_type = pay_type || this.pay_type;
      this.getSignInfo();
      if (isWeiXin() && pay_type == ALI_PAY_TYPE ) this.hintState = true;
    },
    // 看看这大哥以前充过没
    async getUserInfo() {
      try {
        let userInfo = localStorage.getItem("userInfo");
        if (userInfo) {
          this.userInfo = JSON.parse(userInfo);
          this.appkey = GameList[0].appkey // 目前只有一个游戏，暂时写死；后续在服务端配置多游戏后，由服务端返回游戏appkey
          const r = await getRoleInfo({
            open_id: this.userInfo.open_id,
            appkey: this.appkey
          })
          if (r.content) {
            this.username = r.content.user_name;
            this.user_id = r.content.user_id;
            this.balance = r.content.token_coin;
            this.pf_id = r.content.pf_id;
            this.getServerList((serverList) => {
              this.roleList = serverList.find(item => item.value === r.content.server_num).children;
              this.server = r.content.server_num;
              this.server_name = r.content.server_name;
              this.role = r.content.role_id;
              this.role_name = r.content.role_name;
              this.getSignInfo();
            });
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    initGameConfig() {
      this.gameList = GameList.map(item => {
        return {
          text: item.name,
          value: item.appkey
        }
      })
      // 这里拿微信授权，随便用个appkey
      // if (isWeiXin()) wxSdkInit(GameList[0].appkey);
    },
    /**
     * 获取区服信息
     */
    async getServerList(cb) {
      if (!this.username || !this.appkey) return;
      const params = {
        user_name: this.username.trim(),
        appkey: this.appkey
      }
      const r = await userRole(params);
      this.lastParams = params;
      if(r.content && r.content.length) {
        const serverList = [];
        r.content.map(item => {
          const exist = serverList.findIndex(serverItem => serverItem.value === item.server_num);
          if (exist !== -1) {
            serverList[exist].children.push({
              value: item.role_id,
              text: item.role_name,
              user_id: item.user_id,
              pf_id: item.pf_id
            })
          } else {
            serverList.push({
              text: item.server_name,
              value: item.server_num,
              children: [
                {
                  value: item.role_id,
                  text: item.role_name,
                  user_id: item.user_id,
                   pf_id: item.pf_id
                }
              ]
            })
          }
          this.balance = item.token_coin
        })
        this.serverList = serverList;
        cb && cb(serverList)
      }
    },
    async getSignInfo() {
      if (!this.server || !this.role) return;
      const params = {
        appkey: this.appkey,
        server_num: this.server,
        role_id: this.role,
      };
      const sign = sort_ASCII(params)
      const r = await signInInfo({ ...params, sign });
      this.canSign = r.content.can_sign
    },
    // 点击签到按钮
    async execSign() {
      if (!this.role || !this.appkey || !this.server) {
        this.signVisible = true;
        return;
      }
      const params = {
        appkey: this.appkey,
        server_num: this.server,
        role_id: this.role,
        time: Date.parse(new Date()) / 1000,
      }
      const sign = sort_ASCII(params)
      const r = await signIn({ ...params, sign });
      this.signDays = r.content.sign_days;
      this.canSign = r.content.can_sign
      this.signVisible = true;
    },
    // 给我充 往死里充
    async placeOrder() {
      if (!this.selectAmount && this.selectAmount !== 0) this.$toast("请选择充值金额");
      if (!this.role) this.$toast("请选择角色信息");
      // 信息缺失
      if ((!this.selectAmount && this.selectAmount !== 0) || !this.role) return;
      
      // 在微信中选择支付宝
      if (isWeiXin() && this.pay_type == ALI_PAY_TYPE) {
         const { role_id } = this.$route.query;
         if (role_id) {
           this.hintState = true;
           return;
         }
        this.$replaceLink("/pay/wallet", { 
          user_id: this.user_id,
          user_name: this.username.trim(),
          role_id: this.role,
          appkey: this.appkey,
          role_name: this.role_name,
          s_a: this.selectAmount,
          o_a: this.otherAmount,
          server_num: this.server,
          pay_type: this.pay_type
        });
        return; 
      }

      // if (!isWeiXin() && this.pay_type == WX_PAY_TYPE) {
      //   this.$toast("请前往微信公众号支付");
      //   return;
      // }

      const money = this.selectAmount !== 'other' ? this.amountList[this.selectAmount] : this.otherAmount;

      this.$toast.loading({ message: "下单中..." });
      // 下单即绑定当前账号
      this.bindRole();
      const r = await tokenOrder({
        user_id: this.user_id,
        role_id: this.role,
        role_name: this.role_name,

        money: money,
        appkey: this.appkey,
        server_num: this.server,
        pay_type: this.pay_type
      })
      // if (this.pay_type == WX_PAY_TYPE) {
      //   this.toCharge(r.content.order_sn)
      // } else {
      this.$toast.clear();
      const sync_notify_url = `${window.location.origin}${window.location.pathname}?user_id=${this.user_id}&user_name=${this.username.trim()}&appkey=${this.appkey}&`;
      // 渠道支付宝跳转链接有长度限制
      const aliUrl = `${TOKEN_PAY_URL}?order_sn=${r.content.order_sn}&sync_notify_url=${encodeURIComponent(sync_notify_url)}`;
      window.open(aliUrl, "_self");
      // }
    },
    // 微信支付
    async toCharge(order_sn) {
      const r = await tokenOrderPay({
        open_id: this.userInfo.open_id_s,
        order_sn
      })
      this.$toast.clear();
      const { nonceStr, paySign, timeStamp, signType } = r.content;
      wx.chooseWXPay({
        timestamp: timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
        nonceStr, // 支付签名随机串，不长于 32 位
        package: r.content.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
        signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
        paySign, // 支付签名
        success: res => {
          this.$toast("支付成功");
          // 获取角色列表接口中有账户余额信息 用来刷新余额
          this.getServerList()
        },
        fail: err => {
          console.log(err);
          this.$toast("支付失败");
        },
        cancel: () => {
          this.$toast("支付取消");
        }
      });
    },
    bindRole() {
      localStorage.setItem("appkey", this.appkey);
      if (this.userInfo) {
        roleBind({
          open_id: this.userInfo.open_id,
          user_id: this.user_id,
          appkey: this.appkey,
          server_num: this.server,
          role_id: this.role,
          server_name: this.server_name,
          role_name: this.role_name,
          pf_id: this.pf_id
        })
      }
    },
    refreshAmount() {
      this.refreshState = true;
      this.getServerList(() => {
        setTimeout(() => {
          // 让动画多转一会
          this.refreshState = false;       
        }, 1000);
      })
    }
  }
}
</script>

<style lang="scss" module>
.wallet {
  min-height: 100%;
  background: #F6F5F8;
  color: #252C33;
  font-size: 12px;
  padding-bottom: 50px;
  .banner {
    width: 100%;
    height: 146px;
    display: block;
  }
  .selectAccount {
    background: #FFFFFF;
    border-radius:3px;
    width:361px;
    height:142px;
    margin: 5px auto;
    padding: 15px 0 0 27px;
    .accountInput {
      margin-bottom: 15px;
      input {
        width: 126px;
      }
      .sign {
        display: inline-block;
        width: 80px;
        height: 30px;
        margin-left: 45px;
        vertical-align: middle;
      }
    }
    .selectWrap {
      display: flex;
      > span:nth-child(01) {
        flex: none;
        margin-top: 10px;
      }
      .selectGroup  {
        > div {
          display: flex;
        }
        > div:nth-child(1) {
          margin-bottom: 10px;
          .brief {
            margin-left: 10px;
            color: #CACACA;
            display: flex;
            align-items: center;;
            > img {
              width:13px;
              height: 13px;
              display: inline-block;
              margin-right: 5px;
            }
          }
        }
      }
    }
  }
  .balance {
    width:361px;
    height: 66px;
    margin: 6px auto;
    background: url("//static.hzwxbz3.cn/Lianyun/font_end/wap/wallet_balance.png") no-repeat;
    background-size: 100% 100%;
    color: #FFFFFF;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 25px;
    > div:nth-child(1) {
      > p {
        font-size: 11px;
        margin-top: 12px;
      }
    }
    :global {
      .yw-shuaxin1 {
        display: inline-block;
        margin-left: 8px;
      }
    }
    .refreshStateActive {
      transform: rotate(360deg);
      transition: all 1000ms ease-in;
    }
  }
  .money {
    width:361px;
    height:118px;
    background:rgba(255,255,255,1);
    border-radius:3px;  
    margin: 7px auto;
    padding: 10px 20px;
    > div:nth-child(1) {
      padding: 9px 0;
      border-bottom: 1px solid #e6e6e6;
      font-size: 14px;
      margin-bottom: 10px;
    }
    .amountItem {
      width: 73px;
      height: 24px;
      line-height: 24px;
      text-align: center;
      border:1px solid #e6e6e6;
      display: inline-block;
      margin-right: 7px;
      margin-bottom: 7px;
      &.active {
        border-color: #FF9600;
      }
    }
    .otherAmount {
      display: inline-block;
      width: 73px;
      height: 24px;
      background:rgba(248,248,248,1);
      border:1px solid rgba(243, 243, 243, 1);
      line-height: 24px;  
      text-align: center;
      &.active {
        border-color: #FF9600;
      }
      span {
        color: #CACACA;
       }
      input {
        -webkit-appearance: none;
        width:38px;
        height:17px;
        background:rgba(255,255,255,1);
        border:1px solid #e6e6e6;
        display: inline-block;
        text-align: center;
        line-height: 17px;
        margin-right: 5px;
      }
    }
  }
  .payType {
    @extend .money;
    padding: 10px 0;
    height: 135px;
    > div:nth-child(1) {
      padding: 9px 0;
      margin: 0 15px;
    }
  }
  .submit {
    width: calc(100% - 14px);
    margin: auto;
    border: none;
  }
  .popUp {
    padding: 15px;
    border-radius: 4px;
    width: 250px;
    h3 {
      color: #02A7F0;
      font-size: 14px;
      margin-bottom: 10px;
    }
    p {
      line-height: 1.4;
      margin-bottom: 10px;
      letter-spacing: 1px;
      > span {
        color: #02A7F0;
      }
    }
  }
  .signPopUp {
    padding: 15px;
    border-radius: 4px;
    width: 320px;
    p {
      text-align: center;
      font-size: 15px;
      line-height: 24px;  
    }
    .selectRole {
      margin: 40px 0;
    }
    .signSuccess {
      margin: 10px 0 20px 0;
    }
    .title {
      margin-bottom: 12px;
      font-size: 17px;
    }
  }
  .hint {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 100;
    background-image: url("//static.hzwxbz3.cn/Lianyun/font_end/wap/out_pay.png?v=1");
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .refreshHint {
    color: #757575;
    font-size: 11px;
    padding: 0 10px;/*  */
  }
}

.input {
  -webkit-appearance: none;
  &::-webkit-input-placeholder {
		line-height: 22px;
  }
  border:1px solid #e6e6e6;
  padding: 6px;
  &::-webkit-input-placeholder { 
    color: #CACACA;
  }
}

</style>